import {
  addDoc,
  collection,
  getDocs,
  orderBy,
  query,
  QuerySnapshot,
  Timestamp,
} from 'firebase/firestore';
import { db } from 'src/firebase';
import { Terms } from 'src/term.interface';

const defaultTerms: Terms = {
  content: '',
  timestamp: Timestamp.fromMillis(Date.now()),
  version: 1,
};

class TermsService {
  fetchTerms = async (): Promise<Terms | null> => {
    // fetch terms from firestore under the terms collection, the one with the latest timestamp
    const termsRef = collection(db, 'terms');
    const q = query(termsRef, orderBy('timestamp', 'desc'));
    const querySnapshot = (await getDocs(q)) as QuerySnapshot<Terms>;
    if (querySnapshot.docs.length > 0) {
      return querySnapshot.docs[0]?.data() || defaultTerms;
    }
    return null;
  };

  createTerms = async (): Promise<void> => {
    const termsRef = collection(db, 'terms');
    await addDoc(termsRef, defaultTerms);
  };
}

export const termsService = new TermsService();
